import FooterComponent from "@/components/FooterUI";
import DiscordIcon from "@/assets/spheron-specific/discord-icon.svg";
import GithubIcon from "@/assets/spheron-specific/git-icon.svg";
import TwitterIcon from "@/assets/spheron-specific/twitter-icon.svg";

const Footer = () => {
  const footerProps = {
    showLogo: false,
    showStatus: false,
    showThemeButtons: false,
    copyrightText: "Supernoderz © 2024",
    iconButtons: [
      // {
      //   id: 1,
      //   icon: (
      //     <GithubIcon className="w-5 h-5 text-base-icon dark:text-dark-base-icon" />
      //   ),
      //   handleClick: () => window.open('https://github.com/spheronFdn/'),
      // },
      {
        id: 2,
        icon: (
          <TwitterIcon className="w-5 h-5 text-base-icon dark:text-dark-base-icon" />
        ),
        handleClick: () => window.open("https://twitter.com/supernoderz"),
      },
      {
        id: 3,
        icon: (
          <DiscordIcon className="w-5 h-5 text-base-icon dark:text-dark-base-icon" />
        ),
        handleClick: () => window.open("https://sphn.wiki/discord"),
      },
    ],
    links: [
      // {
      //   id: 1,
      //   text: 'Documentation',
      //   handleClick: () => window.open('https://docs.spheron.network/'),
      // },
      // {
      //   id: 2,
      //   text: 'Join Community',
      //   handleClick: () => window.open('https://community.spheron.network/'),
      // },
      // {
      //   id: 3,
      //   text: 'Changelog',
      //   handleClick: () => window.open('https://spheron.network/changelog/'),
      // },
    ],
  };
  return (
    <div className="mt-10">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FooterComponent {...footerProps} />
    </div>
  );
};

export default Footer;
